import styles from '../agents.module.css';

import clsxm from '@/lib/clsxm';

import type { IndustryContent } from './types';
import { CheckGlyph, delay, SectionHeading, Stage } from '../primitives';
import { useReveal } from '../useReveal';

/** One capability that matters most in this industry, shown in depth. */
export default function IndustrySpotlight({
  spotlight,
}: {
  spotlight: IndustryContent['spotlight'];
}) {
  const { ref, state } = useReveal<HTMLDivElement>(0.2);

  return (
    <section id='spotlight' className='py-20 sm:py-28'>
      <div className='mx-auto max-w-7xl px-3 sm:px-6 lg:px-8'>
        <Stage
          variant='ink'
          halftoneAt='100% 100%'
          halftoneReach={65}
          className='px-5 py-14 sm:px-12 sm:py-20'
        >
          <div className='grid gap-14 lg:grid-cols-12 lg:items-center lg:gap-12'>
            <div className='min-w-0 px-1 lg:col-span-5'>
              <SectionHeading
                invert
                size='md'
                title={spotlight.title}
                tail={spotlight.tail}
                lead={spotlight.lead}
              />
              <ul className='mt-9 space-y-3.5'>
                {spotlight.points.map((point) => (
                  <li
                    key={point}
                    className='flex gap-3 text-[15px] leading-6 text-[#d4d4ea]'
                  >
                    <span className='mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-primary-500/25 text-primary-200'>
                      <CheckGlyph className='h-3 w-3' />
                    </span>
                    {point}
                  </li>
                ))}
              </ul>
            </div>

            <div
              ref={ref}
              data-reveal={state}
              className={clsxm(styles.reveal, 'min-w-0 lg:col-span-7')}
            >
              <p className='sr-only'>{spotlight.description}</p>
              <div aria-hidden='true' className={styles.rv} style={delay(0)}>
                {spotlight.visual}
              </div>
            </div>
          </div>
        </Stage>
      </div>
    </section>
  );
}
